import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyType } from '../api/types';

const useVehicleBodyTypeOptions = () => {
    const { t } = useTranslation('common');

    return useMemo(() => {
        const bodyTypeOptions = [
            {
                value: BodyType.Coupe,
                label: t('common:options.bodyTypes.coupe'),
            },
            {
                value: BodyType.Convertible,
                label: t('common:options.bodyTypes.convertible'),
            },
            {
                value: BodyType.Hatchback,
                label: t('common:options.bodyTypes.hatchback'),
            },
            {
                value: BodyType.Mpv,
                label: t('common:options.bodyTypes.mpv'),
            },
            {
                value: BodyType.Suv,
                label: t('common:options.bodyTypes.suv'),
            },
            {
                value: BodyType.Sedan,
                label: t('common:options.bodyTypes.sedan'),
            },
            {
                value: BodyType.Van,
                label: t('common:options.bodyTypes.van'),
            },
            {
                value: BodyType.Wagon,
                label: t('common:options.bodyTypes.wagon'),
            },
        ];

        return bodyTypeOptions;
    }, [t]);
};

export default useVehicleBodyTypeOptions;
